import React, { forwardRef, useContext } from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Form, Input, Modal, notification } from 'antd'
import { EditableList } from '../../compnents/list/EditableList'
import { Columns } from './columns'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import styles from './appllication.module.css'
import { ThemeContext } from '../../theme/ThemeContext'
import moment from 'moment'
import { DateTimeFormatSimpleOnly } from '../../models/datetime'
import { Query } from './Query'
import { Category } from '../../models/category'
import { selectChainId, selectTenantId } from '../../app/applicationSlice'
import {
  getchainInventoryReceiptslist,
  getExportExcelDBCKAsync,
  getRemoveReceiptsFn,
} from './chainSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'
import { traceRoute } from '../../layouts/layoutSlice'
import { ProcurementBusiness } from './ProcurementBusiness'
import { ReturnBusiness } from './ReturnBusiness'
import { ReturnBusinessBranch } from './ReturnBusinessBranch'
import { ReturnBusinessHead } from './ReturnBusinessHead'
import {
  DateRangeFieldName,
  DateRangeType,
  getDateRange,
} from '../../compnents/form/DateSelect'

export const ChainTransferApplicationRef = () => {
  const theme = useContext(ThemeContext)

  const location: any = useLocation()

  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const [exportBtnLoading, setExportBtnLoading] = useState(false)

  const [activeKey, setActiveKey] = useState('0')

  const storageParams =
  JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + activeKey) || '{}'
  )

  const [params, setParams] = useState<any>({
    current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 10,
    recepitsDateStart: storageParams?.recepitsDateStart || head,
    recepitsDateEnd: storageParams?.recepitsDateEnd || tail,
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
  })

  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  const getPageList = () => {
    setPageLoading(true)
    dispatch(
      getchainInventoryReceiptslist({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    const savedTab = localStorage.getItem('LSYWActiveTab')
    if (savedTab) setActiveKey(savedTab)
  }, [])

  const exportExcel = () => {
    setExportBtnLoading(true)
    dispatch(
      getExportExcelDBCKAsync({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = tenantId != chainId ? '申领业务.xlsx' : '调拨出库.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .finally(() => setExportBtnLoading(false))
  }

  useEffect(() => {
    if (activeKey == '0' && params.current) {
      sessionStorage.setItem(
        location.pathname + '_' + activeKey,
        JSON.stringify({ ...params })
      )
    }
  }, [activeKey, params])

  return (
    <Col className={styles.main}>
      <TabBar
        activeKey={activeKey}
        onChange={(v) => {
          setActiveKey(v)
          localStorage.setItem('LSYWActiveTab', v)
        }}
      >
        <TabPane key='0' tab={tenantId != chainId ? '申领业务' : '调拨出库'}>
          <Col
            style={{
              backgroundColor: theme.pn,
              borderRadius: 10,
              display: 'flex',
              flexDirection: 'column',
              height: 'calc(100% - 0px)',
              overflow: 'hidden',
              padding: '10px 15px 0 15px',
            }}
          >
            <Query
             activeKey={activeKey}
              exportBtnLoading={exportBtnLoading}
              onValueChange={(v: any) => {
                setParams({
                  ...params,
                  ...v,
                  current: v?.current
                    ? v?.current
                    : storageParams?.current
                    ? storageParams?.current
                    : 1,
                })
              }}
              exportExcel={() => {
                exportExcel()
              }}
            />
            <EditableList
              style={{ flex: 1 }}
              scroll={{ x: '30rem' }}
              loading={pageLoading}
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              onRow={(r) => ({
                onDoubleClick: () => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: [
                        tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                        tenantId == chainId ? '调拨出库' : '申领业务',
                      ],
                      name:
                        tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      backName:tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      path:
                        tenantId == chainId
                          ? '/chainTransferOutbound'
                          : 'chainClaimBusiness',
                      category:
                        tenantId == chainId ? Category.LSDBCK : Category.SLYW,
                      selectId: r.id,
                      detail: { ...r },
                    },
                  })
                },
              })}
              pageSizeOptions={['10', '20', '50', '100']}
              rowKey={(m: any) => m.id}
              columns={Columns(
                params.size * (params.current - 1),
                (action: any, t: any) => {
                  switch (action) {
                    case 'list':
                      setParams({ ...params })
                      break
                    case 'delete':
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;是否确认删除？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          dispatch(getRemoveReceiptsFn(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              notification.success({
                                message: '删除成功',
                              })
                              setParams({ ...params })
                            })
                        },
                      })
                  }
                },
                tenantId != chainId ? Category.SLYW : Category.LSDBCK
              )}
              onChangePage={(current, size) =>
                setParams({ ...params, current, size: size || 10 })
              }
              sticky
            />
          </Col>
        </TabPane>
        {tenantId == chainId && (
          <>
            <TabPane key='1' tab='采购业务'>
              <ProcurementBusiness  activeKey={activeKey}/>
            </TabPane>
            <TabPane key='2' tab='退货业务'>
              <ReturnBusiness  activeKey={activeKey}/>
            </TabPane>
            <TabPane key='4' tab='门店退货业务'>
              <ReturnBusinessHead  activeKey={activeKey}/>
            </TabPane>
          </>
        )}
        {tenantId != chainId && (
          <TabPane key='3' tab='退货业务'>
            <ReturnBusinessBranch  activeKey={activeKey}/>
          </TabPane>
        )}
      </TabBar>
    </Col>
  )
}

export const ChainTransferApplication = forwardRef(ChainTransferApplicationRef)
